import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { IComponentsRegistrySiteConfig } from '../symbols'

const componentsRegistrySiteConfig: SiteConfigFn<IComponentsRegistrySiteConfig> = ({ api, funcLib }) => {
	const shouldLoad = api.features.isActive('platform')

	if (!shouldLoad) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	const serviceTopology = api.rootConfig.getServiceTopology()
	const url = api.originalRequest.getUrl() ?? ''
	const headers = api.originalRequest.getHeaders() || {}
	const componentsOnSite = api.rendererModel.getSiteMetaData()?.renderHints?.componentsCount
	const useNewStatics = api.env.getExperiments()['specs.thunderbolt.useEENewStatics'] === true

	const librariesTopology = funcLib.getRegistryComponentsLibraries({
		originalRequest: { url, headers },
		serviceTopology: serviceTopology || ({} as any),
		componentsOnSite,
		useNewStatics,
	})

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			librariesTopology,
		},
	}
}

const name = 'componentsRegistry'

export const config = { site: componentsRegistrySiteConfig, name }
